import React from 'react';
import Pficon from 'components/Pficon';

export const getTransformedTagName = (name) => {
  if (name === 'NPS') {
    return (
      <span>
        {name} <sup>&reg;</sup>
      </span>
    );
  }
  if (name === 'Tracker') {
    return (
      <span className="flex-inline flex-items-center">
        <Pficon
          type="scheduling"
          className="color-purple-6 text-size-primary line-height-clear"
        />
        &nbsp;
        {name}
      </span>
    );
  }
  return name;
};
